export default __webpack_public_path__ + "static/media/icon-more.3a2e6de6.svg";